import { Flex, Typography } from '@iheartjane/reefer';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import {
  OrderCompleteCheckIcon,
  OrderCompleteContainer,
  OrderCompleteSubContainer,
  OrderRatingFiveStars,
} from '../../components';
import type { RootLoaderType } from '../../data-access';
import { useTypedRouteLoaderData } from '../../hooks';
import { useCartInfoForTracking } from '../../providers';
import { trackCustomerRating } from '../../util';

export const OrderCompleteMobile = () => {
  const { kiosk, store } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { reservationId } = useParams<{ reservationId: string }>();
  const { cartInfo, setCartInfo } = useCartInfoForTracking();

  const [rating, setRating] = useState<number>(0);

  const onRatingPress = useCallback(
    (index: number) => {
      trackCustomerRating({
        kiosk,
        store,
        starRating: index + 1,
        ...cartInfo,
      });
      setCartInfo(null);
      setRating(index + 1);
    },
    [cartInfo, kiosk, setCartInfo, store]
  );

  return (
    <OrderCompleteContainer
      alignItems="center"
      flexDirection="column"
      justifyContent="flex-end"
      width="100%"
      height="100%"
    >
      <Flex width="32%" mb={24}>
        <OrderCompleteCheckIcon width="100%" height="100%" color="text-info" />
      </Flex>

      {reservationId && (
        <Typography color="text-info" mb={16} variant="header" as="h1">
          Order #{reservationId}
        </Typography>
      )}

      <Typography
        color="text-info"
        textAlign="center"
        variant="title-bold"
        as="h2"
      >
        All set! Grab your order at the counter.
      </Typography>

      <OrderCompleteSubContainer
        alignItems="center"
        flexDirection="column"
        mb={48}
        mt={48}
        px={32}
        py={24}
        width="83%"
      >
        <Typography
          textAlign="center"
          color="text-info"
          mb={24}
          variant="header-bold"
          as="h2"
        >
          {rating
            ? 'Thanks for your feedback!'
            : 'How was your kiosk experience today?'}
        </Typography>
        <Flex flexDirection="row">
          <OrderRatingFiveStars
            isMobile
            onRatingPress={onRatingPress}
            rating={rating}
          />
        </Flex>
      </OrderCompleteSubContainer>
    </OrderCompleteContainer>
  );
};
